import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

import ViewportPadding from "../ViewportPadding";

const styles = ({ theme }) => {
  return {
    root: {
      backgroundColor: theme.colors.primary5
    },
    step: {
      backgroundColor: theme.colors.primary5,
      padding: [theme.padding.md, 0],
      borderBottom: "1px solid #CECECE"
    },
    active: {
      backgroundColor: theme.colors.primary5
    },
    inner: {
      display: "flex",
      alignItems: "center"
    },
    title: {
      height: 26,
      width: "80%",
      maxWidth: 400,
      backgroundColor: theme.colors.black,
      opacity: 0.07,
      borderRadius: 4
    },
    index: {
      height: 26,
      width: 44,
      backgroundColor: theme.colors.black,
      opacity: 0.07,
      borderRadius: 100,
      marginRight: theme.padding.lg
    }
  };
};
const FlowSkeleton = ({ classes, steps }) => {
  return (
    <div className={classes.root}>
      {Array.from(new Array(steps)).map((step, index) => (
        <div key={index}>
          <div
            className={`${classes.step} ${index === 0 ? classes.active : ""}`}
          >
            <ViewportPadding>
              <div className={classes.inner}>
                <div className={classes.index} />
                <div className={classes.title} />
              </div>
            </ViewportPadding>
          </div>
        </div>
      ))}
    </div>
  );
};

FlowSkeleton.propTypes = {
  steps: PropTypes.number
};

FlowSkeleton.defaultProps = {
  steps: 4
};

export default injectSheet(styles)(FlowSkeleton);
